module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers'), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('div', {
    staticClass: "main-top"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name1")))]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("about.main.value1")))]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/jIlHwsxlPMQQkj1MWYLfcApWpFg%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.qrtext")))])])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.value2")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/8vODqMHK15fuy2yaT9ew2aKggio%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.value3")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/UDgvU9tYxf6wqsrhO3E6D2ROLtw%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name4")))]), _vm._v(" "), _c('div', {
    staticClass: "main-flex"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/y7hWu2o9w5GnWraBaYvnda8lykU%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("about.main.value4")))])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name5")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.value5")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/KRzy86VgxoTB5vZdqNSZMAiQQmY%3D",
      "alt": ""
    }
  })]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-453090c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/pages/about.vue
// module id = 43
// module chunks = 0